import {
  IBudget,
  IBudgetData
} from './index'
import {ITravel, Travel} from '@/entities'

export class Budget implements IBudget {
  id?: number
  tourist_count: number
  budget_from?: number
  budget_to?: number
  travel?: ITravel

  constructor(data?: IBudgetData) {
    this.id = data?.id
    this.tourist_count = data?.tourist_count || 1
    this.budget_from = data?.budget_from
    this.budget_to = data?.budget_to
    let travel = data?.travel
    if (travel) {
      this.travel = new Travel(travel)
    }
  }

  validate(): boolean {
    return (this.validateTouristsCount() && this.validatePrices())
  }

  validateTouristsCount(): boolean {
    return this.tourist_count > 0
  }

  validatePrices(): boolean {
    let from = this.budget_from
    let to = this.budget_to
    return !!from && from > 0 && !!to && to > from
  }
}
